export default "__VITE_ASSET__Dk2mLARw__"